import React, { useState } from "react";
//import { useStaticQuery, graphql } from "gatsby"
//import PropTypes from "prop-types"
//import { StaticImage } from "gatsby-plugin-image"
import { useIntl, Link, FormattedMessage, changeLocale } from "gatsby-plugin-react-intl";
import imgLogo from "/src/images/logo.svg";
import Hamburger from "hamburger-react";
import { StaticImage } from "gatsby-plugin-image";
import Search from "./component-search-result";

const HeaderSp = ({ siteTitle, location, languages, pathWithoutLang }) => {
  const [isOpen, setOpen] = useState(false);

  const handleChange = (e) => {
    console.log(e.target.value);
    changeLocale(e.target.value);
  };


  const [isChildmenuOpen, setChildmenuOpen] = useState([]);
  const [isGrandChildmenuOpen, setGrandChildmenuOpen] = useState([]);
  const handleToggle = (e) => {
    if (e.currentTarget.id === "SpMenu__back") {
      setChildmenuOpen([]);
    } else {
      setChildmenuOpen({
        ...isChildmenuOpen,
        [e.currentTarget.id]: isChildmenuOpen[e.currentTarget.id]
          ? false
          : true,
      });
    }
  };
  const handleGrandToggle = (e) => {
    if (e.currentTarget.id === "SpMenu__grand_back") {
      setGrandChildmenuOpen([]);
    } else {
      setGrandChildmenuOpen({
        ...isGrandChildmenuOpen,
        [e.currentTarget.id]: isGrandChildmenuOpen[e.currentTarget.id]
          ? false
          : true,
      });
    }
  };

  const intl = useIntl();
  //const pathWithoutLang = location.pathname.replace(/\/de/g, '')
  //const [changeLocaleLang, setChangeLocaleLang] = useState(intl.locale);

  //const [searchActive, setSearchActive] = useState(false);
  const searchActive = false
  
  const getSearch = () => {
    return searchActive ? "active" : "";
  };
  //const setSearch = () => {
  //  setSearchActive(!searchActive);
  //};

  return (
    <header
      id="commonHeaderSp"
      className={`header${location.pathname.replace(
        /\//g,
        "-"
      )} ${getSearch()}`}
    >
      <div className="headerInner">
        <h1>
          <Link to="/">
            <img src={imgLogo} className="ImgHeaderLogo" alt="company logo" />
          </Link>
        </h1>
        <nav className={isOpen ? "opened" : "closed"}>
          <div className="searchIcon">
            
            <div className={`menu menu-search menu-search-sp ${getSearch()}`}>
              <ul className="menu_inner">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 23 23"
                    className="searchIconSearch"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g stroke="#fff" strokeWidth="2">
                        <g transform="translate(-1502.000000, -39.000000) translate(1503.000000, 40.000000)">
                          <circle cx="8.029" cy="8.029" r="8.029" />
                          <path
                            strokeLinecap="square"
                            d="M14.206 14.206L19.799 19.799"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                  <input
                    type="text"
                    className="base_underline"
                    placeholder="Searchterm"
                  />
                </div>
              </ul>
            </div>
          </div>
          <Hamburger
            toggled={isOpen}
            toggle={setOpen}
            color="#666666"
            size={24}
          />
          <div
            className="menuSlide menuSlide_Base"
            style={
              isOpen
                ? { transform: "translateX(0)" }
                : { transform: "translateX(150%)" }
            }
          >
            <ul>
              <li>
                <div
                  onClick={handleToggle}
                  onKeyDown={handleToggle}
                  role = "button"
                  tabIndex={0}
                  id="SpMenu_product"
                  className={`parent ${
                    pathWithoutLang.match(/products/) && "active"
                  }`}
                >
                  <span>{intl.locale === "en" ? `Products` : `Produkte`}</span>
                </div>
                <div
                  className="menuSlide_Base"
                  style={
                    isChildmenuOpen["SpMenu_product"]
                      ? { transform: "translateX(0)" }
                      : { transform: "translateX(150%)" }
                  }
                >
                  <div className="ChildBack">
                    <div
                      onClick={handleToggle}
                      onKeyDown={handleToggle}
                      role = "button"
                      tabIndex={0}
                      id="SpMenu__back"
                      className="SpMenu__back"
                    >
                      back
                    </div>
                  </div>
                  <ul className="subtitle-wrap">
                    <li className="subtitle">
                      <div
                        onClick={handleGrandToggle}
                        onKeyDown={handleGrandToggle}
                        role = "button"
                        tabIndex={0}
                        id="SpMenu_product_medical"
                      >
                        {intl.locale === "en"
                          ? `Medical device`
                          : `Medizinische Produkte`}
                      </div>
                    </li>
                    <li className="subtitle">
                      <Link to="/products/non-medical-device/">
                        {intl.locale === "en"
                          ? `Non-medical device`
                          : `Nichtmedizinische Produkte`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/products/cleaning-robot/">
                        {intl.locale === "en"
                          ? `Self-driving cleaning robot`
                          : `Selbstfahrender Reinigungsroboter`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/products/communication/">
                        {intl.locale === "en"
                          ? `Communication`
                          : `Kommunikation`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/products/imaging/">
                        {intl.locale === "en"
                          ? `Imaging and detection`
                          : `Bildgebung und Früherkennung`}
                      </Link>
                    </li>
                  </ul>
                  <div
                    className="GrandChild"
                    style={
                      isGrandChildmenuOpen["SpMenu_product_medical"]
                        ? { transform: "translateX(0)" }
                        : { transform: "translateX(150%)" }
                    }
                  >
                    <div className="ChildBack">
                      <div
                        onClick={handleGrandToggle}
                        onKeyDown={handleGrandToggle}
                        role = "button"
                        tabIndex={0}
                        id="SpMenu__grand_back"
                        className="SpMenu__back"
                      >
                        back
                      </div>
                    </div>
                    <div className="bg-white">
                      <div className="grandchild-product-wrap my-4">
                        <Link
                          to="/products/medical-device/hal-motion-principal/"
                          className="grandchild-product flex-row"
                        >
                          <div className="flex-column-sm-9 txt txt-black">
                            {intl.locale === "en"
                              ? `Motion Priniple of HAL`
                              : `Bewegungsprinzip des HAL`}
                          </div>
                          <div className="flex-column-sm-3">
                            <StaticImage
                              src="../images/MicrosoftTeams-image_11.png"
                              alt={siteTitle ? siteTitle : ""}
                              className=""
                              loading="eager"
                            />
                          </div>
                        </Link>
                        <Link
                          to="/products/medical-device/hal-joint/"
                          className="grandchild-product flex-row"
                        >
                          <div className="flex-column-sm-9 txt txt-black">
                            {intl.locale === "en"
                              ? `HAL Single Joint`
                              : `HAL Single Joint`}
                          </div>
                          <div className="flex-column-sm-3">
                            <StaticImage
                              src="../images/MicrosoftTeams-image_8.png"
                              alt={siteTitle ? siteTitle : ""}
                              className="ImgHeaderProduct"
                              loading="eager"
                            />
                          </div>
                        </Link>
                        <Link
                          to="/products/medical-device/hal-limb/"
                          className="grandchild-product flex-row"
                        >
                          <div className="flex-column-sm-9 txt txt-black">
                            <p>
                              {intl.locale === "en"
                                ? `HAL Lower Limb Type`
                                : `HAL Lower Limb Type`}
                            </p>
                          </div>
                          <div className="flex-column-sm-3">
                            <StaticImage
                              src="../images/MicrosoftTeams-image_9.png"
                              alt={siteTitle ? siteTitle : ""}
                              className="ImgHeaderProduct"
                              loading="eager"
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div
                  onClick={handleToggle}
                  onKeyDown={handleToggle}
                  role = "button"
                  tabIndex={0}
                  id="SpMenu_treatment"
                  className={`parent ${
                    pathWithoutLang.match(/treatment/) && "active"
                  }`}
                >
                  <span>
                    {intl.locale === "en" ? `HAL Treatment` : `HAL Treatment`}
                  </span>
                </div>
                <div
                  className="menuSlide_Base"
                  style={
                    isChildmenuOpen["SpMenu_treatment"]
                      ? { transform: "translateX(0)" }
                      : { transform: "translateX(150%)" }
                  }
                >
                  <div className="ChildBack">
                    <div
                      onClick={handleToggle}
                      onKeyDown={handleToggle}
                      role = "button"
                      tabIndex={0}
                      id="SpMenu__back"
                      className="SpMenu__back"
                    >
                      back
                    </div>
                  </div>
                  <ul className="subtitle-wrap">
                    <li className="subtitle">
                      <Link to="/treatment/cvd/">
                        {intl.locale === "en"
                          ? `Cerebrovascular disease (CVD)`
                          : `Zerebrovaskulären Erkrankungen`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/treatment/spinal/">
                        {intl.locale === "en"
                          ? `Spinal cord injury`
                          : `Rückenmarksverletzungen`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/treatment/pnd/">
                        {intl.locale === "en"
                          ? `Progressive neuromuscular diseases`
                          : `Progressive neuromuskuläre Erkrankungen`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/treatment/znb/">
                        {intl.locale === "en"
                          ? `About ZNB/ Our therapists`
                          : `Das ZNB / Unsere Therapeuten`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/treatment/testimonials/">
                        {intl.locale === "en"
                          ? `Testimonials`
                          : `Erfahrungsberichte`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/treatment/faq/">
                        {intl.locale === "en"
                          ? `Frequently Asked Questions`
                          : `Häufig gestellte Fragen (FAQ)`}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <div
                  onClick={handleToggle}
                  onKeyDown={handleToggle}
                  role = "button"
                  tabIndex={0}
                  id="SpMenu_training"
                  className={`parent ${
                    pathWithoutLang.match(/training/) && "active"
                  }`}
                >
                  <span>
                    {intl.locale === "en" ? `Neuro HALFIT` : `Neuro HALFIT`}
                  </span>
                </div>
                <div
                  className="menuSlide_Base"
                  style={
                    isChildmenuOpen["SpMenu_training"]
                      ? { transform: "translateX(0)" }
                      : { transform: "translateX(150%)" }
                  }
                >
                  <div className="ChildBack">
                    <div
                      onClick={handleToggle}
                      onKeyDown={handleToggle}
                      role = "button"
                      tabIndex={0}
                      id="SpMenu__back"
                      className="SpMenu__back"
                    >
                      back
                    </div>
                  </div>
                  <ul className="subtitle-wrap">
                    <li className="subtitle">
                      <Link to="/training/elderly/">
                        {intl.locale === "en"
                          ? `Mobility Wellness`
                          : `Bewegungswohlbefinden`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/training/athletes/">
                        {intl.locale === "en"
                          ? `Athletic Performance`
                          : `Sportliche Leistungsfähigkeit`}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div
                  onClick={handleToggle}
                  onKeyDown={handleToggle}
                  role = "button"
                  tabIndex={0}
                  id="SpMenu_about"
                  className={`parent ${
                    pathWithoutLang.match(/company/) && "active"
                  }`}
                >
                  <span>
                    <FormattedMessage id="common.AboutUs" />
                  </span>
                </div>
                <div
                  className="menuSlide_Base"
                  style={
                    isChildmenuOpen["SpMenu_about"]
                      ? { transform: "translateX(0)" }
                      : { transform: "translateX(150%)" }
                  }
                >
                  <div className="ChildBack">
                    <div
                      onClick={handleToggle}
                      onKeyDown={handleToggle}
                      role = "button"
                      tabIndex={0}
                      id="SpMenu__back"
                      className="SpMenu__back"
                    >
                      back
                    </div>
                  </div>
                  <ul className="subtitle-wrap">
                    <li className="subtitle">
                      <Link to="/company/about/">
                        {intl.locale === "en" ? `About us` : `Über uns`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/company/">
                        {intl.locale === "en"
                          ? `Cyberdyne Inc.`
                          : `Cyberdyne Inc.`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/company#founder">
                        {intl.locale === "en" ? `Founder` : `Gründer`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/company/mission/">
                        {intl.locale === "en"
                          ? `Vision and Mission`
                          : `Vision und Auftrag`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/company/cybernics/">
                        {intl.locale === "en" ? `Cybernics` : `Cybernics`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/company/access/">
                        {intl.locale === "en" ? `Access` : `Anfahrt`}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div
                  onClick={handleToggle}
                  onKeyDown={handleToggle}
                  role = "button"
                  tabIndex={0}
                  id="SpMenu_news"
                  className={`parent ${
                    pathWithoutLang.match(/news/) && "active"
                  }`}
                >
                  <span>
                    {intl.locale === "en" ? `Media Room` : `Multimedia`}
                  </span>
                </div>
                <div
                  className="menuSlide_Base"
                  style={
                    isChildmenuOpen["SpMenu_news"]
                      ? { transform: "translateX(0)" }
                      : { transform: "translateX(150%)" }
                  }
                >
                  <div className="ChildBack">
                    <div
                      onClick={handleToggle}
                      onKeyDown={handleToggle}
                      role = "button"
                      tabIndex={0}
                      id="SpMenu__back"
                      className="SpMenu__back"
                    >
                      back
                    </div>
                  </div>
                  <ul className="subtitle-wrap">
                    <li className="subtitle">
                      <Link to="/news/">
                        {intl.locale === "en" ? `Latest News` : `Aktuelles`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/research/">
                        {intl.locale === "en"
                          ? `Clinical Publications`
                          : `Klinische Studien`}
                      </Link>
                    </li>
                    <li className="subtitle">
                      <Link to="/recruit/">
                        {intl.locale === "en" ? `Recruiting` : `Karriere`}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <Link to="/contact/">
                  {intl.locale === "en" ? `Contact` : `Kontakt`}
                </Link>
              </li>

              <li className="last-child-search">
                <div
                  onClick={handleToggle}
                  onKeyDown={handleToggle}
                  role = "button"
                  tabIndex={0}
                  id="SpMenu_search"
                  className="parent"
                >
                  <span>
                    {intl.locale === "en" ? `Search` : `Suche`}
                  </span>
                </div>
                <div
                  className="menuSlide_Base"
                  style={
                    isChildmenuOpen["SpMenu_search"]
                      ? { transform: "translateX(0)" }
                      : { transform: "translateX(150%)" }
                  }
                >
                  <div className="ChildBack">
                    <div
                      onClick={handleToggle}
                      onKeyDown={handleToggle}
                      role = "button"
                      tabIndex={0}
                      id="SpMenu__back"
                      className="SpMenu__back"
                    >
                      back
                    </div>
                    <Search />
                  </div>
                </div>
              </li>

              <li className="headerSp_logo__lang">
                <div className="changeLocale flex-row">
                  <div className="flex-column-6">
                    <span className="changeLocale_title">{intl.locale === "en" ? `Language` : `Sprache`}</span>
                  </div>
                  <div className="flex-column-6">
                    <div className="cp_ipselect cp_sl01">
                      <select
                        required
                        onChange={handleChange}
                        defaultValue={intl.locale}
                      >
                        <option value="de">
                          DE
                        </option>
                        <option value="en">
                          EN
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </li>

            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default HeaderSp;
